const ChargeFields = [
  {
    id: Math.random() * 10,
    name: "Charge_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Charge_Code",
        label: "Charge Code",
        type: "text",
        min: 1,
        max: Infinity,
        autoFocus: true,
      },
      {
        id: Math.random() * 10,
        name: "Charge_Name",
        label: "Charge Name",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Effective_From",
        label: "Effective From",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Event_Code",
        label: "Event Code",
        type: "InputDropForQuery",
        masterName: "Event_Master",
      },
      {
        id: Math.random() * 10,
        name: "Event_Type",
        label: "Event Type",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Voucher_Type",
        label: "Voucher Type",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Debit_Account",
        label: "Debit Account",
        type: "InputDropForQuery",
        masterName: "All_Accounts",
      },
      {
        id: Math.random() * 10,
        name: "Credit_Account",
        label: "Credit Account",
        type: "InputDropForQuery",
        masterName: "All_Accounts",
      },
      {
        id: Math.random() * 10,
        name: "Charge_Header_Text",
        label: "Charge Header",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Calcualtion_Value",
        label: "Calcualtion Value",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Based_On",
        label: "Based On",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "GST_Applicable",
        label: "GST Applicable",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "GST_Type",
        label: "GST Type",
        type: "text",
        min: 1,
        max: Infinity,
      },
    ],
  },
];

export { ChargeFields };
